import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/auth/Login';
import Blacklist from '../pages/misc/Blacklist';
import MobileVerification from '../pages/auth/MobileVerification';
// components
import LoadingLogoScreen from '../components-custom/LoadingLogoScreen';
// routes
import { PATH } from '../routes/paths';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingLogoScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  if (user.blacklisted) return <Blacklist />;

  if (user.state === 'suspend') {
    return <Navigate to={PATH.misc.suspend} />;
  }
  if (!user?.mobile_verified) return <MobileVerification />;
  if (!user?.email_verified) {
    if (new Date().getTime() - new Date(user.date_joined).getTime() > 172800000) {
      return <Navigate to={PATH.auth.activation} />;
    }
  }

  return <>{children}</>;
}
